import { getRequest, postRequest, putRequest } from './api-requests';
import apiConfig from '../../../api-config';

export const Users = Object.freeze({
    details: () => getRequest(`${apiConfig.base_url}/web/user/me`),
    list: (data = {}) => {
        let getString = '';
        if (data.sortBy !== undefined) {
            getString += `?sort_by=${data.sortBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`;
        }
        return getRequest(`${apiConfig.base_url}/web/user${getString}`);
    },
    single: id => getRequest(`${apiConfig.base_url}/web/user/${id}`),
    freeOwners: (identifier, details) => {
        let getString = '';

        if(identifier !== undefined && identifier === 1) {
            getString = `?free_users=${identifier}`
        }

        return postRequest(`${apiConfig.base_url}/web/user/free_users${getString}`, details)
    },
    freeManagers: (identifier, companyId, details) => {
        let getString = '';

        if(identifier !== undefined && identifier === 2) {
            getString = `?free_users=${identifier}&company=${companyId}`
        }
        return postRequest(`${apiConfig.base_url}/web/user/free_users${getString}`, details)
    },
    add: details => postRequest(`${apiConfig.base_url}/web/user`, details),
    edit: (id, details) => putRequest(`${apiConfig.base_url}/web/user/${id}`, details)
});


// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-users.js